var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSteak(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#steak_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.224 11.25c-3.2 0-6.08 2.777-7.338 7.073-.731 2.504-3.135 12.447-20.292 19.922-9.625 4.19-1.13 10.38 11.228 10.38 8.526 0 18.892-2.944 26.42-11.521 4.477-5.101 3.843-14.766-1.356-20.694-2.918-3.334-5.994-5.16-8.662-5.16zM45 29.988a3.75 3.75 0 110-7.5 3.75 3.75 0 010 7.5zM60.342 8.982C54.834 2.708 48.782 0 43.225 0 34.953 0 27.773 5.996 25.09 15.163 19.336 31.56.16 24.88 0 41.207-.133 54.784 14.803 60 28.044 60c.657 0 1.309-.013 1.956-.038 10.287-.4 21.952-4.347 31.698-15.45 8.237-9.385 7.63-25.293-1.356-35.53zM57.471 40.8c-9.362 10.664-20.225 13.252-27.69 13.541-.575.023-1.154.034-1.737.034-8.401 0-15.918-2.32-19.616-6.054-1.914-1.932-2.83-4.24-2.803-7.06.044-4.63 1.764-5.584 7.72-8.178 5.686-2.476 13.477-5.866 17.051-16.054l.05-.141.04-.143c1.975-6.756 6.978-11.12 12.738-11.12 4.374 0 8.832 2.445 12.891 7.069C63.164 20.73 63.79 33.6 57.471 40.8z",
    fill: "#91C300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "steak_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h67.5v60H0z"
  })))));
}

export default SvgSteak;